module.exports = __webpack_public_path__ + "static/media/logo_alt.c96f0756.xcf";